// onia-wishlist 10/5 (myOnia C, approved 10/5): hearts on cards (B, beside the name), the product page save button,
// the header count, the phone-menu count, footer links and the first-save toast. One list of product handles.
// ponytail: guest list lives in localStorage only; the signed-in copy (customer metafield via app proxy) plugs into `store`.
(() => {
  const KEY = 'onia:wishlist', SEEN = 'onia:wishlist:toast';
  const get = (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } };
  const put = (k, v) => { try { localStorage.setItem(k, v); } catch (e) {} };
  const store = {
    all() { try { return JSON.parse(get(KEY)) || []; } catch (e) { return []; } },
    has(h) { return this.all().includes(h); },
    toggle(h) {
      const l = this.all(), i = l.indexOf(h);
      i < 0 ? l.unshift(h) : l.splice(i, 1);
      put(KEY, JSON.stringify(l));
      document.dispatchEvent(new CustomEvent('onia:wishlist', { detail: { handle: h, saved: i < 0, list: l } }));
      return i < 0;
    }
  };
  window.OniaWishlist = store;

  const H = '<svg class="ow-ic" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 20.2s-7.6-4.6-9.1-9.4C1.8 7.3 4 4.2 7.3 4.2c2 0 3.6 1.1 4.7 2.8 1.1-1.7 2.7-2.8 4.7-2.8 3.3 0 5.5 3.1 4.4 6.6-1.5 4.8-9.1 9.4-9.1 9.4z"/></svg>';
  const handleOf = (href) => ((href || '').match(/\/products\/([^/?#]+)/) || [])[1];
  const label = (on, name) => (on ? 'Remove ' : 'Save ') + (name || 'this') + (on ? ' from' : ' to') + ' wishlist';

  const paint = (btn) => {
    const on = store.has(btn.dataset.owHandle);
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on);
    btn.setAttribute('aria-label', label(on, btn.dataset.owName));
  };
  const button = (h, name, cls) => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'ow-btn ' + cls; b.dataset.owHandle = h; b.dataset.owName = name || '';
    b.innerHTML = H; paint(b); return b;
  };

  // cards: one heart per product-grid-item, beside the name (B). Cards re-render on filter/sort, so watch for new ones.
  const cards = (root) => root.querySelectorAll('product-grid-item .product__grid__info').forEach((info) => {
    if (info.querySelector(':scope > .ow-card')) return;
    const a = info.querySelector('a[href*="/products/"]'), h = handleOf(a && a.getAttribute('href'));
    if (h) info.prepend(button(h, a.getAttribute('aria-label'), 'ow-card'));
  });

  // product page: square save button beside Add to bag
  const pdp = () => {
    const h = handleOf(location.pathname), add = document.querySelector('.product__submit__buttons .btn--add-to-cart');
    if (!h || !add || add.parentElement.classList.contains('ow-pdp')) return;
    const w = document.createElement('div'); w.className = 'ow-pdp';
    add.before(w); w.append(add, button(h, document.querySelector('h1')?.textContent.trim(), 'ow-save'));
  };

  // footer: Wishlist + myOnia after Search (desktop list), else after About Us (phone list)
  const footer = () => document.querySelectorAll('footer ul, .footer ul').forEach((ul) => {
    if (ul.querySelector('[data-ow-foot]')) return;
    const links = [...ul.querySelectorAll(':scope > li > a')];
    const at = links.find((a) => a.getAttribute('href') === '/search') || links.find((a) => /^about us$/i.test(a.textContent.trim()));
    if (!at) return;
    const li = at.parentElement;
    [['myOnia', '/account'], ['Wishlist', '/pages/favorites']].forEach(([t, href]) => {
      const c = li.cloneNode(false), a = document.createElement('a');
      a.href = href; a.textContent = t; a.dataset.owFoot = ''; c.append(a); li.after(c);
    });
  });

  const counts = () => {
    const n = store.all().length;
    document.querySelectorAll('[data-ow-count]').forEach((a) => {
      const b = a.querySelector('b'); b.textContent = n; b.hidden = !n;
      a.classList.toggle('is-on', n > 0);
      a.setAttribute('aria-label', 'Wishlist, ' + n + ' saved');
    });
    document.querySelectorAll('[data-ow-menu]').forEach((a) => { a.textContent = 'Wishlist (' + n + ')'; });
  };

  const signedIn = () => !!(window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.customerId);
  const toast = () => {
    if (get(SEEN)) return;
    put(SEEN, '1');
    const t = document.createElement('div'); t.className = 'ow-toast'; t.setAttribute('role', 'status');
    t.innerHTML = signedIn()
      ? '<span>Saved to your wishlist.</span><a href="/pages/favorites">View</a>'
      : '<span>Saved. It stays on this device. Sign in to keep it on every device.</span><a href="/pages/favorites">View</a><a class="ow-toast__b" href="/account">Sign in</a>';
    document.body.append(t);
    setTimeout(() => t.remove(), 7000);
  };

  document.addEventListener('click', (e) => {
    const b = e.target.closest('.ow-btn'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (store.toggle(b.dataset.owHandle)) toast();
  }, true);
  document.addEventListener('onia:wishlist', (e) => {
    document.querySelectorAll('.ow-btn').forEach((b) => b.dataset.owHandle === e.detail.handle && paint(b));
    counts();
  });
  addEventListener('storage', (e) => { if (e.key === KEY) { document.querySelectorAll('.ow-btn').forEach(paint); counts(); } });

  // sign-in panel (signed out only; the snippet renders nothing for a signed-in customer)
  const si = document.querySelector('[data-ow-si]');
  if (si) {
    let back;
    const open = () => { back = document.activeElement; si.querySelectorAll('img').forEach((i) => { i.loading = 'eager'; }); const of = si.querySelector('[data-ow-si-offer]'); if (of) of.hidden = !(window.__attentive && window.__attentive.trigger); si.hidden = false; document.documentElement.classList.add('ow-si-open'); si.querySelector('[data-ow-si-go]').focus(); };
    const close = () => { si.hidden = true; document.documentElement.classList.remove('ow-si-open'); back && back.focus && back.focus(); };
    const sheet = () => { // step 2: Shopify's own sheet
      const sa = document.querySelector('shopify-account'), r = sa && sa.shadowRoot;
      const t = r && r.querySelector('button, [role="button"], a');
      if (t) t.click(); else if (sa) sa.click(); else location.href = '/account';
    };
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-ow-si-close]')) return close();
      if (e.target.closest('[data-ow-si-go]')) { close(); return sheet(); }
      // 15% = Attentive's own pop-up (Welcome email subscribers journey, HELLO15), so the code arrives the same way as everywhere else
      // ponytail: creative ids hardcoded (10/6 popups: phone 1472173 / desktop 1472145; the old 1215123/1215128 were switched off 10/6);
      // if marketing swaps the pop-up, swap these
      if (e.target.closest('[data-ow-si-offer]')) { close(); return window.__attentive.trigger(null, null, null, matchMedia('(max-width: 767px)').matches ? 1472173 : 1472145); }
      const a = e.target.closest('a[href="/account"], a[href$="onia.com/account"]');
      if (a && !e.metaKey && !e.ctrlKey) { e.preventDefault(); e.stopPropagation(); open(); }
    }, true);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !si.hidden) close(); });
    const offers = () => document.querySelectorAll('.ow-empty [data-ow-si-offer]').forEach((b) => { b.hidden = !(window.__attentive && window.__attentive.trigger); });
    addEventListener('load', () => { offers(); setTimeout(offers, 3000); });
    // the photo is lazy; start it the moment a pointer or finger reaches an account link, so it is there when the panel opens
    const warm = (e) => { if (e.target.closest && e.target.closest('a[href="/account"]')) si.querySelectorAll('img').forEach((i) => { i.loading = 'eager'; }); };
    ['pointerover', 'pointerdown', 'focusin'].forEach((ev) => document.addEventListener(ev, warm, { passive: true }));
    window.OniaSignIn = { open, close, sheet };
  }

  // Wishlist grid (Wishlist page, and the first 4 on the myOnia home). Real product JSON, so price, photo and stock are live.
  const money = (c) => '$' + (c / 100).toFixed(c % 100 ? 2 : 0);
  const esc = (t) => String(t).replace(/[&<>"]/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]));
  const pj = {};
  const product = (h) => pj[h] || (pj[h] = fetch('/products/' + h + '.js').then((r) => (r.ok ? r.json() : r.status === 404 ? null : undefined)).catch(() => undefined));
  const tile = (h, p) => {
    const si = Math.max(0, p.options.findIndex((o) => /size/i.test(o.name || o)));
    const opts = p.variants.map((v) => `<option value="${v.id}"${v.available ? '' : ' disabled'}>${esc(v.options[si] || v.title)}${v.available ? '' : ' (sold out)'}</option>`).join('');
    const any = p.variants.some((v) => v.available), one = p.variants.length === 1;
    const img = (p.featured_image || '').replace(/^\/\//, 'https://');
    return `<div class="ow-tile"><a href="/products/${h}" class="ow-tile__img">${img ? `<img src="${img}${img.includes('?') ? '&' : '?'}width=600" alt="${esc(p.title)}" loading="lazy">` : ''}</a>
<div class="ow-tile__n"><a href="/products/${h}">${esc(p.title)}</a></div><span class="ow-mut">${money(p.price)}</span>
<div class="ow-buy">${one ? '' : `<select aria-label="Size for ${esc(p.title)}"${any ? '' : ' disabled'}><option value="">Size</option>${opts}</select>`}
<button type="button" class="ow-add" data-ow-add${one && any ? ` data-id="${p.variants[0].id}"` : ''}${any ? '' : ' disabled'}>${any ? 'Add to bag' : 'Sold out'}</button></div></div>`;
  };
  const grids = async () => {
    const list = store.all();
    for (const g of document.querySelectorAll('[data-ow-wl-grid]')) {
      const max = +g.dataset.max || 999, hs = list.slice(0, max);
      const got = await Promise.all(hs.map(product)), gone = hs.filter((h, i) => got[i] === null);  // null = 404, undefined = network
      const ps = got.map((p, i) => p && [hs[i], p]).filter(Boolean);
      g.innerHTML = ps.map(([h, p]) => tile(h, p)).join('');
      g.querySelectorAll('.ow-tile').forEach((t, i) => t.querySelector('.ow-tile__n').append(button(ps[i][0], ps[i][1].title, 'ow-card')));
      const page = g.closest('[data-ow-wl]'), sec = g.closest('[data-ow-home-wl]');
      // a saved product that no longer exists (deleted or unpublished) leaves the list for good
      if (gone.length) { put(KEY, JSON.stringify(store.all().filter((h) => !gone.includes(h)))); counts(); if (synced) push(); }
      const n = g.dataset.max ? list.length : ps.length;
      if (page) {
        page.querySelector('[data-ow-wl-sub]').textContent = n ? n + ' saved' + (synced ? ' \u00b7 on every device you sign in on' : '') : '';
        page.querySelector('[data-ow-wl-empty]').hidden = !!n;
        const note = page.querySelector('[data-ow-wl-note]'); if (note) note.hidden = !n;
      }
      if (sec) { sec.hidden = !list.length; sec.querySelector('[data-ow-home-wl-all]').textContent = 'See all ' + list.length; }
    }
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-ow-add]'); if (!b || b.disabled || b.classList.contains('is-busy')) return;
    const sel = b.parentElement.querySelector('select'), id = b.dataset.id || (sel && sel.value);
    if (!id) { sel.focus(); sel.classList.add('is-need'); setTimeout(() => sel.classList.remove('is-need'), 1600); return; }
    b.classList.add('is-busy');
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .then((r) => { if (!r.ok) throw r; return fetch('/cart.js').then((x) => x.json()); })
      .then((cart) => { b.classList.remove('is-busy'); b.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart }, bubbles: true }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        const d = document.querySelector('[data-drawer="drawer-cart"]'); if (d) d.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
        setTimeout(() => { b.textContent = 'Add to bag'; }, 2500); })
      .catch(() => { b.classList.remove('is-busy'); b.textContent = 'Try again'; setTimeout(() => { b.textContent = 'Add to bag'; }, 2500); });
  });
  document.addEventListener('onia:wishlist', () => { if (document.querySelector('[data-ow-wl-grid]')) grids(); });

  // myOnia home: greeting by the shopper's own clock, and "I shop for" (saved to the account, custom.shop_for, via the worker;
  // Liquid renders the saved pick, so the hero photo is right on first paint)
  const greet = document.querySelector('[data-ow-greet]');
  if (greet) { const hr = new Date().getHours(); greet.textContent = hr < 12 ? 'Good morning' : hr < 18 ? 'Good afternoon' : 'Good evening'; }
  const sf = document.querySelector('[data-ow-shopfor]');
  if (sf) {
    const set = (v) => sf.querySelectorAll('button').forEach((b) => { b.setAttribute('aria-checked', b.dataset.v === v); b.classList.toggle('is-on', b.dataset.v === v); });
    const split = document.querySelector('.ow-hero .ow-split');
    const show = (v) => { set(v); if (split) { if (v === 'men' || v === 'women') split.dataset.pick = v; else delete split.dataset.pick; } };
    const save = (v) => fetch('/apps/wishlist', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ shopfor: v }) }).catch(() => {});
    const local = get('onia:shopfor');
    show(sf.dataset.owShopfor || local || 'both');
    if (!sf.dataset.owShopfor && local) save(local);   // a pick made on this device before the account kept it
    sf.addEventListener('click', (e) => { const b = e.target.closest('button'); if (b) { put('onia:shopfor', b.dataset.v); show(b.dataset.v); save(b.dataset.v); } });
  }
  // signed in: myOnia doors lead to our home; Shopify's own account pages stay one tap away from it
  // (signed in, Liquid's routes.account_url is the full https://shopify.com/<id>/account?... address, not "/account")
  const doors = () => signedIn() && document.querySelectorAll('a[href="/account"]:not([data-ow-keep]), a[href^="https://shopify.com/"][href*="/account?"]:not([data-ow-keep])').forEach((a) => { a.href = '/pages/myonia'; });

  // signed in: the list lives on the customer record (app proxy -> onia-wishlist worker). First sync on a device merges this
  // device's saves in; after that the account copy wins on load, and every change is saved back. Any failure: stay local.
  const cid = signedIn() && String(ShopifyAnalytics.meta.page.customerId), SYNC = 'onia:wishlist:synced';
  let synced = false, dirty = false, q2;
  const push = () => fetch('/apps/wishlist', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ list: store.all() }) })
    .then((r) => { if (r.ok) put(SYNC, cid); }).catch(() => {});
  if (cid) {
    fetch('/apps/wishlist', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : Promise.reject(r)))
      .then(({ list }) => {
        // merge this device's saves only when they are a guest's or this customer's own taps from before the load finished;
        // a list left by another customer on a shared device is never merged into this account
        const prev = get(SYNC), merge = !prev || (prev === cid && dirty);
        const next = merge ? [...new Set([...store.all(), ...list])] : list;
        put(KEY, JSON.stringify(next)); synced = true;
        if (next.length !== list.length) push(); else put(SYNC, cid);
        document.querySelectorAll('.ow-btn').forEach(paint); counts();
        if (document.querySelector('[data-ow-wl-grid]')) grids();
      }).catch(() => {});
    document.addEventListener('onia:wishlist', (e) => { if (!synced) { dirty = true; return; } if (e.detail && e.detail.handle) { clearTimeout(q2); q2 = setTimeout(push, 400); } });
  } else if (get(SYNC)) { put(KEY, '[]'); put(SYNC, ''); }   // signed out after a signed-in visit: the account's list leaves this device

  // myOnia orders (10/6): real Shipped / Delivered + dates from the worker (Admin fulfillments; last 60 days only). Any failure: Liquid's wording stays.
  const bar = document.querySelector('[data-ow-steps]'), pos = document.querySelectorAll('[data-ow-po]');
  if (cid && (bar || pos.length)) {
    const day = (iso) => new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }), LBL = ['Confirmed', 'Packed', 'Shipped', 'Delivered'], RET_DAYS = 14;
    fetch('/apps/wishlist?orders=1', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : Promise.reject(r)))
      .then(({ orders }) => {
        const by = Object.fromEntries((orders || []).map((o) => [o.id, o]));
        const o = bar && by[bar.dataset.owSteps];
        if (o) {
          bar.querySelectorAll('div').forEach((d, i) => d.classList.toggle('d', i <= o.step));
          document.querySelectorAll('[data-ow-stl] span').forEach((sp, i) => { sp.classList.toggle('d', i <= o.step); if (i === o.step && i > 0) sp.textContent = LBL[i] + ' ' + day(o.at); });
        }
        pos.forEach((c) => {
          const p = by[c.dataset.owPo]; if (!p || p.step < 2) return;
          c.querySelector('.ow-po__a b').textContent = (p.step === 3 ? 'Delivered ' : 'Shipped ') + day(p.at);
          // Return only inside Loop's window: 14 days from delivery (US, Canada and Rest of World policies, read 10/6)
          // ponytail: window hardcoded; if Loop's policy changes, change RET_DAYS
          if (p.step === 3 && Date.now() - new Date(p.at) < RET_DAYS * 864e5 && !c.querySelector('[data-ow-ret]')) {
            let x = c.querySelector('.ow-po__x'); if (!x) { x = document.createElement('span'); x.className = 'ow-po__x'; c.append(x); }
            x.insertAdjacentHTML('beforeend', '<a href="/pages/returns" data-ow-ret>Return</a>');
          }
        });
      }).catch(() => {});
  }

  const run = () => { cards(document); pdp(); footer(); doors(); counts(); if (document.querySelector('[data-ow-wl-grid]')) grids(); };
  run();
  let q; new MutationObserver(() => { clearTimeout(q); q = setTimeout(() => cards(document), 50); })
    .observe(document.body, { childList: true, subtree: true });
})();
